import { useContext, useEffect, useState } from "react";
import Constant from "./Constant";
import { useHistory } from "react-router";
import Context from "../Context";
import { confirmPasswordReset } from "./utilities/Authentication";
import styled from "styled-components";
import bannerImage from "../Images/banner1.png";
import Logo from "../Images/Logonew.jpeg";

export default function EmailSetPassword() {
  const history = useHistory();
  const { dispatch } = useContext(Context);

  const [error, setError] = useState("");
  const [getSuccessMessage, setSuccessMessage] = useState("");
  const [registerForm, setRegisterForm] = useState({
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const flowDetailsRaw = localStorage.getItem("passwordResetEmailFlow");
    const flowDetails = flowDetailsRaw ? JSON.parse(flowDetailsRaw) : null;
    if (!flowDetails?.verifiedToken || !flowDetails?.email) {
      history.replace("/forgot-password");
    }
  }, [history]);

  function handleFormChange(e) {
    setRegisterForm({
      ...registerForm,
      [e.target.name]: e.target.value,
    });
  }

  function showHidePassword(e) {
    e.preventDefault();
    setShowPassword(!showPassword);
  }

  function handleFormSubmit(e) {
    e.preventDefault();

    if (registerForm.password !== registerForm.confirmPassword) {
      setError("Password and confirm password should match.");
      return;
    }

    let password = registerForm.password;
    let strength = 0;
    if (password.match(/[a-z]+/)) strength += 1;
    if (password.match(/[A-Z]+/)) strength += 1;
    if (password.match(/[0-9]+/)) strength += 1;
    if (password.match(/[$@#&!]+/)) strength += 1;

    if (strength !== 4) {
      setError(
        "Password should have uppercase, lowercase, number and special character."
      );
      return;
    }

    const flowDetailsRaw = localStorage.getItem("passwordResetEmailFlow");
    const flowDetails = flowDetailsRaw ? JSON.parse(flowDetailsRaw) : null;
    if (!flowDetails?.verifiedToken || !flowDetails?.email) {
      setError("Your reset session expired. Please request OTP again.");
      return;
    }

    confirmPasswordReset({
      verifiedToken: flowDetails.verifiedToken,
      email: flowDetails.email,
      password: registerForm.password,
    }).then((response) => {
      if (response.status === Constant.statusSuccess) {
        localStorage.removeItem("passwordResetEmailFlow");
        dispatch({ type: "logout", payload: null });
        setSuccessMessage(response.message);
        setTimeout(function () {
          history.push("/login");
        }, 2000);
      } else {
        setError(response.message);
      }
    });
  }

  return (
    <Root
      style={{
        background: `url(${bannerImage})`,
      }}
    >
      <div className="container">
        <img className="logo" src={Logo} alt="StoryTent logo" />
        <h1>Set New Password</h1>
        <p>Create a strong password for your account.</p>
        {error ? <div className="error">{error}</div> : null}
        {getSuccessMessage ? (
          <div className="success">{getSuccessMessage}</div>
        ) : null}

        <form onChange={handleFormChange} onSubmit={handleFormSubmit} className="form">
          <div className="passwordField">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New password"
              name="password"
              value={registerForm.password}
            />
            <button
              className="password_show"
              type="button"
              onClick={showHidePassword}
            >
              <i
                className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"}
                aria-hidden="true"
              ></i>
            </button>
          </div>
          <div className="passwordField">
            <input
              type={showPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm password"
              value={registerForm.confirmPassword}
            />
            <button
              className="password_show"
              type="button"
              onClick={showHidePassword}
            >
              <i
                className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"}
                aria-hidden="true"
              ></i>
            </button>
          </div>
          <button type="submit" className="button">
            Save Password
          </button>
        </form>
      </div>
    </Root>
  );
}

const Root = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover !important;
  background-position: center !important;
  padding: 24px;

  .container {
    width: 100%;
    max-width: 420px;
    background-color: #0f1817;
    border-radius: 20px;
    padding: 32px 28px;
    box-shadow: -1px 6px 30px 12px rgba(0, 0, 0, 0.45);
    text-align: center;
  }

  .logo {
    width: 80px;
    height: 80px;
    object-fit: cover;
    margin-bottom: 16px;
  }

  h1 {
    color: white;
    font-size: 28px;
    margin-bottom: 12px;
  }

  p {
    color: white;
    margin-bottom: 18px;
  }

  .error {
    color: #ff7b7b;
    margin-bottom: 12px;
    font-size: 14px;
  }

  .success {
    color: #6be585;
    margin-bottom: 12px;
    font-size: 14px;
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .passwordField {
    width: 100%;
    display: flex;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
  }

  input {
    width: 100%;
    padding: 11px 12px;
    border: none;
    outline: none;
  }

  .password_show {
    background-color: white;
    border: none;
    padding: 0 12px;
  }

  .button {
    width: 100%;
    background-color: #6c63ff;
    color: white;
    font-weight: 600;
    cursor: pointer;
    border: none;
    border-radius: 8px;
    padding: 11px 12px;
  }
`;
